import React from "react";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";

function FitrosCupones({
    title,
    ci, handleCi,
    dataSorteos, sorteoSelected, handleSorteoSelected, handleSorteoSearch, loadingCargarSorteo,
    dataLocales, localSelected, handleLocalSelected,
    fechaProcDesde, handleFechaProcDesde,
    fechaProcHasta, handleFechaProcHasta,
    fechaFacturaDesde, handleFechaFacturaDesde,
    fechaFacturaHasta, handleFechaFacturaHasta,
    handleBuscar,
}) {
    const inputBaseClass = "w-full rounded-lg border border-gray-200 bg-[#f1f5f9] px-3 py-2 text-sm text-gray-700 outline-none transition focus:border-blue-200 focus:ring-2 focus:ring-blue-200";

    const autocompleteInputSx = {
        '& .MuiOutlinedInput-root': {
            backgroundColor: '#f1f5f9',
            borderRadius: '0.5rem',
            fontSize: '0.875rem',
        },
    };

    return (
        <div className="bg-white rounded-xl border border-gray-200 p-4 sm:p-6 mb-6">
            <div className="flex justify-between items-center">
                <h2 className="text-xl font-semibold text-gray-800">{title}</h2>
            </div>

            <div className="mt-4 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                <div>
                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">
                        Cédula
                    </label>
                    <input
                        type="text"
                        value={ci}
                        onChange={(e) => handleCi(e.target.value)}
                        placeholder="Ingrese cédula de identidad"
                        autoCapitalize="none"
                        autoCorrect="off"
                        className={inputBaseClass}
                    />
                </div>

                <div>
                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">
                        Sorteo
                    </label>
                    <Autocomplete
                        disablePortal
                        options={dataSorteos}
                        sx={{ width: '100%' }}
                        loading={loadingCargarSorteo}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Seleccione"
                                size="small"
                                sx={autocompleteInputSx}
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <React.Fragment>
                                            {loadingCargarSorteo ? <CircularProgress color="inherit" size={20} /> : null}
                                            {params.InputProps.endAdornment}
                                        </React.Fragment>
                                    ),
                                }}
                            />
                        )}
                        onInputChange={(event, newInputValue, reason) => {
                            if (reason === 'input') handleSorteoSearch(newInputValue);
                        }}
                        onChange={(e, value) => handleSorteoSelected(value)}
                        value={sorteoSelected}
                        getOptionLabel={(option) => option?.titulo || ''}
                        isOptionEqualToValue={(option, value) => option?.id === value?.id}
                        loadingText="Cargando..."
                        noOptionsText="No hay opciones"
                    />
                </div>

                <div>
                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">
                        Local
                    </label>
                    <Autocomplete
                        disablePortal
                        options={dataLocales}
                        sx={{ width: '100%' }}
                        renderInput={(params) => (
                            <TextField {...params} label="Seleccione" size="small" sx={autocompleteInputSx} />
                        )}
                        onChange={(e, value) => handleLocalSelected(value)}
                        value={localSelected}
                        getOptionLabel={(option) => option?.nombre_fantasia || option?.razon_social || ''}
                        isOptionEqualToValue={(option, value) => option?.id === value?.id}
                        noOptionsText="No hay opciones"
                    />
                </div>

                <div>
                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">
                        Fecha procesamiento desde
                    </label>
                    <input
                        type="date"
                        value={fechaProcDesde}
                        onChange={(e) => handleFechaProcDesde(e.target.value)}
                        className={inputBaseClass}
                    />
                </div>

                <div>
                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">
                        Fecha procesamiento hasta
                    </label>
                    <input
                        type="date"
                        value={fechaProcHasta}
                        onChange={(e) => handleFechaProcHasta(e.target.value)}
                        className={inputBaseClass}
                    />
                </div>

                <div>
                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">
                        Fecha factura desde
                    </label>
                    <input
                        type="date"
                        value={fechaFacturaDesde}
                        onChange={(e) => handleFechaFacturaDesde(e.target.value)}
                        className={inputBaseClass}
                    />
                </div>

                <div>
                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">
                        Fecha factura hasta
                    </label>
                    <input
                        type="date"
                        value={fechaFacturaHasta}
                        onChange={(e) => handleFechaFacturaHasta(e.target.value)}
                        className={inputBaseClass}
                    />
                </div>
            </div>

            {/* <div className="mt-5 flex justify-end">
                <button
                    onClick={handleBuscar}
                    className="px-6 py-2 bg-[#104063] text-white text-sm font-semibold rounded-lg hover:bg-[#0d3350] transition"
                >
                    Buscar
                </button>
            </div> */}
        </div>
    );
}

export default FitrosCupones;
